import { render, staticRenderFns } from "./OrganizationTree.vue?vue&type=template&id=441966fc&"
import script from "./OrganizationTree.vue?vue&type=script&lang=ts&"
export * from "./OrganizationTree.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports